﻿import * as Kalkulator from './Kalkulator';
import A from './Utilities/A-StudieretningValg';
import B from './Utilities/B-VarighetValg';
import C from './Utilities/C-FulltidDeltidValg';
import D from './Utilities/D-ArstimerProsent';
import E from './Utilities/E-SkolepengerValg';
import H from './Utilities/H-BostedValg';
import { ValgState } from './Store/Valg/Types';
import Resultat from './Models/Resultat';
import { Utbetalingsplan } from './Models/Utbetalingsplan';
import { Satser } from './Utilities/SatserApi';

export const fulltidArstimer = (state: ValgState): number => {
    return state.aStudieretning?.value === A.a2_yrkesfag ? 924 : 784;
};

export const finnMaksArstimer = (state: ValgState, fulltid: number): number => {
    return state.bVarighet?.value === B.b1_heltAr ? fulltid : fulltid / 2;
};

const hentAngittArstimer = (state: ValgState, maksArstimer: number): number => {
    if (state.dArstimerProsent?.vetIkke === true) {
        return maksArstimer;
    }

    if (!state.dArstimerProsent?.verdi) {
        throw Error('Årstimer/Prosent kan ikke være undefined');
    }

    const verdi = Number(state.dArstimerProsent.verdi)

    return state.dArstimerProsent.type === D.d2_prosent
        ? (verdi * maksArstimer) / 100
        : verdi;
};

const hentArstimerForState = (state: ValgState, arstimerMaks: number): number => {
    return state.cFulltidDeltid?.value === C.c1_fulltid ? arstimerMaks : hentAngittArstimer(state, arstimerMaks);
};

export const maksSkolepenger = (state: ValgState, satser: Satser): number => {
    const fullArstimer = fulltidArstimer(state);
    const arstimerMaks = finnMaksArstimer(state, fullArstimer);
    const angitt = hentArstimerForState(state, arstimerMaks);

    return Math.ceil((satser.HoyskoleOgUniversitet.ST01_MaksSkolepengestottePerAr * angitt) / fullArstimer);
};

export const beregnStipendOgLan = (state: ValgState, satser: Satser): number => {
    const fullArstimer = fulltidArstimer(state);
    const arstimerMaks = finnMaksArstimer(state, fullArstimer);
    const angitt = hentArstimerForState(state, arstimerMaks);

    const antallMnd = getAntallMndForBeregning(state);
    const skolepenger = hentSkolepenger(state, satser);

    return Kalkulator.beregnStipendOgLan(
        antallMnd,
        skolepenger,
        satser.HoyskoleOgUniversitet.ST01_MaksBasisstotteperManed,
        angitt / arstimerMaks,
    );
};

export const beregnStipendDelvis = (state: ValgState, satser: Satser): number => {
    const antallMnd = getAntallMndForBeregning(state);
    return Kalkulator.beregnStipendOgLan(antallMnd, 0, satser.HoyskoleOgUniversitet.ST01_MaksBasisstotteperManed, 1);
};

export const beregnAndelStipendOgLan = (state: ValgState, stipendOgLan: number, satser: Satser): Resultat => {
    const skolepenger = hentSkolepenger(state, satser);
    const erBorteboer = state.hBosted?.value === H.h2_borte;
    
    var vetIkkeAarstimer: boolean = false;
    if(state.dArstimerProsent !== null && state.dArstimerProsent !== undefined && state.dArstimerProsent.verdi == undefined) 
        vetIkkeAarstimer = true;

    const antallMnd = getAntallMndForBeregning(state);
    const varighet = getSemesterTypeForBeregning(state);

    return {
        stipendOgLan,
        stipend: Kalkulator.beregnStipend(erBorteboer, stipendOgLan, skolepenger, satser.HoyskoleOgUniversitet.ST01_MaksBasisstotteperManed, antallMnd, vetIkkeAarstimer, satser.HoyskoleOgUniversitet.ST01_MaksSkolepengestottePerAr),
        lan: Kalkulator.beregnLan(erBorteboer, stipendOgLan, skolepenger, satser.HoyskoleOgUniversitet.ST01_MaksBasisstotteperManed, antallMnd, vetIkkeAarstimer, satser.HoyskoleOgUniversitet.ST01_MaksSkolepengestottePerAr, varighet),
    };
};

export const utbetalingsplan = (state: ValgState, stipendOgLan: number, satser: Satser): Utbetalingsplan => {
    const skolepenger = hentSkolepenger(state, satser);

    const semesterType = getSemesterTypeForBeregning(state);
    const antallMnd = getAntallMndForBeregning(state);
    let hostperiode = 0;
    let varperiode = 0;

    if (semesterType === B.b1_heltAr) {
        hostperiode = 5;
        varperiode = 5;
    } else {
        hostperiode = semesterType === B.b2_host ? antallMnd : 0;
        varperiode = semesterType === B.b3_var ? antallMnd : 0;
    }

    return Kalkulator.beregnUtbetalingsplan(hostperiode, varperiode, stipendOgLan, skolepenger);
};

export const hentSkolepenger = (state: ValgState, satser: Satser): number => {
    return state.eSkolepenger?.value === E.e1_ja && state.fSpBelop
        ? Math.max(Math.min(state.fSpBelop, maksSkolepenger(state, satser)), 0)
        : 0;
};

const getAntallMndForBeregning = (state: ValgState): number => {
    if (!state.bVarighet) {
        throw Error('Varighet må være satt for beregning');
    }

    return B.antallMnd(state.bVarighet.value);
};

const getSemesterTypeForBeregning = (state: ValgState): string => {
    if (!state.bVarighet?.value) {
        throw new Error('Beregning feilet pga. B ikke er satt');
    }
    return state.bVarighet.value;
};
